import { render, staticRenderFns } from "./CapexItemEditor.vue?vue&type=template&id=161628d0"
import script from "./CapexItemEditor.vue?vue&type=script&lang=ts"
export * from "./CapexItemEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports